import React from 'react';
const yesItems = ['Tuviste cándida más de 2 veces en el último año', 'Los óvulos te funcionan solo unos días', 'Sospechás que "algo más" está pasando', 'Querés entender la causa y no solo apagar el fuego', 'Estás cansada de gastar una fortuna en farmacia', 'Querés recuperar tu vida íntima sin miedo'];
const noItems = ['Tenés fiebre alta o lesiones graves sin diagnóstico', 'Sospechás una ITS no tratada', 'Estás embarazada sin supervisión médica', 'Buscás reemplazar un tratamiento médico urgente', 'Querés resultados sin ningún cambio de hábito'];
export function ForWhomSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-104">
      <p className="text-brand-magenta text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-105">
        Esto es importante antes de comprar
      </p>
      <h2 className="text-[24px] font-bold text-white mb-8 leading-tight" data-id="element-106">
        ¿Es para vos?
      </h2>

      <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-107">
        <div className="flex-1 rounded-2xl p-5" style={{
        background: 'rgba(10,46,31,0.6)',
        border: '1px solid rgba(0,245,212,0.15)'
      }} data-id="element-108">
          <p className="text-brand-teal font-bold text-base mb-4" data-id="element-109">
            ✅ ESTO ES PARA VOS SI:
          </p>
          <ul className="flex flex-col gap-3" data-id="element-110">
            {yesItems.map((item, i) => <li key={i} className="text-[15px] text-white/85 leading-relaxed flex items-start gap-2" data-id="element-111">
                <span className="text-brand-teal mt-0.5 flex-shrink-0" data-id="element-112">•</span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="flex-1 rounded-2xl p-5" style={{
        background: 'rgba(46,10,10,0.6)',
        border: '1px solid rgba(255,0,110,0.15)'
      }} data-id="element-113">
          <p className="text-brand-magenta font-bold text-base mb-4" data-id="element-114">
            ❌ ESTO NO ES PARA VOS SI:
          </p>
          <ul className="flex flex-col gap-3" data-id="element-115">
            {noItems.map((item, i) => <li key={i} className="text-[15px] text-white/85 leading-relaxed flex items-start gap-2" data-id="element-116">
                <span className="text-brand-magenta mt-0.5 flex-shrink-0" data-id="element-117">
                  •
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="bg-white/[0.04] rounded-xl p-4 border border-white/[0.08]" data-id="element-118">
        <p className="text-[15px] text-brand-muted leading-relaxed" data-id="element-119">
          ⚕️ El Método pH-ZERO es un protocolo de biología funcional
          complementario. No reemplaza el diagnóstico médico profesional. Para
          síntomas graves, consultá a un profesional de salud.
        </p>
      </div>
    </section>;
}